export default defineNuxtPlugin((nuxtApp) => {
  const image = (src: string | null | undefined, width?: number, height?: number, quality?: number): string | null => {
    if (!src) {
      return null
    }

    // If it's already a full URL or data URI, return as is (but add query params if needed)
    if (src.startsWith('http') || src.startsWith('data:')) {
      // If width/height/quality are provided, add query params
      if (width !== undefined || height !== undefined || quality !== undefined) {
        const q: Record<string, string> = {}
        if (width) q.w = width.toString()
        if (height) q.h = height.toString()
        if (quality) q.q = quality.toString()
        else q.q = '60' // default quality
        
        const separator = src.includes('?') ? '&' : '?'
        return src + separator + Object.keys(q).map(k => `${k}=${q[k]}`).join('&')
      }
      return src
    }

    // For local assets, use Nuxt's public directory
    // In Nuxt 3/4, static assets should be in public directory
    // If the path doesn't start with /, assume it's from assets/images (mapped to /images/)
    let assetPath = src
    if (!src.startsWith('/')) {
      // Map assets/images/ paths to /images/ in public directory
      // This maintains compatibility with old code that used ~/assets/images/
      assetPath = `/images/${src}`
    }

    // Add query params if width/height/quality are provided
    if (width !== undefined || height !== undefined || quality !== undefined) {
      const q: Record<string, string> = {}
      if (width) q.w = width.toString()
      if (height) q.h = height.toString()
      if (quality) q.q = quality.toString()
      else q.q = '60' // default quality
      
      return assetPath + '?' + Object.keys(q).map(k => `${k}=${q[k]}`).join('&')
    }

    return assetPath
  }

  const bgImage = (...args: any[]) => {
    let forced = ''
    if (args[4] && args[4] === 'forced') {
      forced = '!important'
    }
    const imageSrc = image(args[0], args[1], args[2], args[3])
    return {
      'background-image': `url("${imageSrc}") ${forced}`,
    }
  }

  // Inject as global properties for use in templates with $image
  nuxtApp.vueApp.config.globalProperties.$image = image
  nuxtApp.vueApp.config.globalProperties.$bgImage = bgImage

  // Also provide for use in composables
  return {
    provide: {
      image,
      bgImage,
    },
  }
})

